/*
 * @Description:客户及商机刷新报价单列表
 * @Version: 2.0
 * @Autor: 胡彩丽 hucaili@qfei.cn
 * @Date: 2023-08-01 09:47:12
 * @LastEditors: 胡彩丽 hucaili@qfei.cn
 */
import { priceService } from '@/api/';
import { defineStore } from 'pinia';
import { Message } from '@arco-design/web-vue';
export const usePricesheetStore = defineStore('getPricesheetList', {
  state: () => ({
    pricesheetList: [],
    priceParams: {},
    isRefresh: false
  }),
  actions: {
    //获取报价单数据列表
    getPricesheetLists(params) {
      this.pricesheetList = [];
      this.priceParams = params;
      return new Promise((resolve, reject) => {
        priceService
          .getPriceTabList(params)
          .then((json) => {
            if (json.error) {
              Message.error(json.error?.msg || '操作失败');
            }
            this.pricesheetList = json.result;
            resolve(json);
          })
          .catch((err) => {
            Message.error(err.message || err.statusText || '报价单数据获取失败');
            reject(err);
          });
      });
    },
    //更新是否刷新的标识
    updateRefresh(flag) {
      this.isRefresh = flag;
    }
  }
});

export default usePricesheetStore;
